import type { FeatureFlagKey, FeatureFlagMap } from "@/types/featureFlag"
import { DEFAULT_FLAGS } from "./featureFlags"

/**
 * Module-level flag store that mirrors the React FeatureFlagContext.
 * Populated by FeatureFlagProvider so service functions outside React
 * can read the current flag state without accessing the React tree.
 */
let _store: FeatureFlagMap = { ...DEFAULT_FLAGS }

export function setFlagStore(flags: FeatureFlagMap): void {
  _store = flags
}

export function getFlagValue(key: FeatureFlagKey): boolean {
  return _store[key] ?? false
}

/**
 * Module-level callback for triggering a feature flag re-fetch from
 * non-React code (e.g. Axios interceptors). Set by FeatureFlagProvider.
 */
let _refreshCallback: (() => Promise<void>) | null = null
let _refreshInFlight: Promise<void> | null = null

export function setFlagRefreshCallback(cb: () => Promise<void>): void {
  _refreshCallback = cb
}

export function triggerFlagRefresh(): void {
  if (_refreshInFlight || !_refreshCallback) return
  _refreshInFlight = _refreshCallback().finally(() => {
    _refreshInFlight = null
  })
}
